import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";

//API
import DataTable from "react-data-table-component";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import toast from "react-hot-toast";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";

//Redux
import { useDispatch } from "react-redux";
import { getTodaysData } from "../../../../common/Validations";

const InvoiceConfirmationModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  // eslint-disable-next-line no-unused-vars
  const [viewInvoiceDataStatus, setViewInvoiceDataStatus] = useState(false);
  const [lineItemData, setLineItemData] = useState([]);

  const [invoiceData, setInvoiceData] = useState();
  const [getDropdownData, setDropdownData] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [totals, setTotals] = useState({
    totalBags: 0,
    totalAmount: 0,
    totalCgst: 0,
    totalSgst: 0,
    totalNetValue: 0,
  });
  const [disable, setDisabled] = useState(false);

  let ewayBillNumberData = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  const lineItemCol = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Load confirm Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.orderQtyLoadConfirm} </p>
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Unit Price",
      cell: (row) => <span>{row?.unitPrice} </span>,
      width: "100px",
    },
    {
      name: "Basic Price",
      selector: (row) => row?.basicPrice || "--",
      cell: (row) => <span>{row?.basicPrice} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Basic Amt",
      selector: (row) => row.basicAmount || "--",
      cell: (row) => <span>{row.basicAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => <span>{row?.cgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => <span>{row?.sgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "IGST",
      cell: (row, index) => (
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            checked={row.isIGST}
            onChange={() => handleIGSTToggle(index)}
            style={{ marginRight: "8px" }}
          />
          {row.isIGST && (
            <InputField
              type="number"
              className="inputBox"
              value={row.igstPercent}
              onChange={(e) => handleIGSTPercentChange(e.target.value, index)}
              placeholder="%"
              style={{ width: "60px" }}
              disabled={true}
            />
          )}
        </div>
      ),
      width: "140px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },

    {
      name: "CGST%",
      selector: (row) => row?.cgst,
      // cell: (row) => <span> {!row.isIGST ? row.cgst : 0} </span>,
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst,
      // cell: (row) => <span> {!row.isIGST ? row.sgst : 0} </span>,
      sortable: true,
      width: "100px",
    },
    {
      name: "Driver",
      selector: (row) => row?.netValue || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.transporterDriverName} </p>
          <p className="m-0 p-0 ">{row?.transporterDriverContact} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Truck No",
      selector: (row) => row?.netValue || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingTruckNo} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
  ];

  useEffect(() => {
    setInvoiceData((invoiceData) => ({
      ...invoiceData,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
  }, [getDropdownData]);

  // ✅ Define the function at the top inside the component
  const calculateTotals = (items) => {
    const totalBags = items.reduce(
      (sum, item) => sum + parseFloat(item?.orderQtyLoadConfirm || 0),
      0
    );
    const totalAmount = items.reduce(
      (sum, item) => sum + parseFloat(item?.basicAmount || 0),
      0
    );
    const totalCgst = items.reduce(
      (sum, item) => sum + parseFloat(item?.cgstValue || 0),
      0
    );
    const totalSgst = items.reduce(
      (sum, item) => sum + parseFloat(item?.sgstValue || 0),
      0
    );
    const totalNetValue = items.reduce(
      (sum, item) => sum + parseFloat(item?.netValue || 0),
      0
    );

    const calculatedTotals = {
      totalBags,
      totalAmount: totalAmount.toFixed(2),
      totalCgst: totalCgst.toFixed(2),
      totalSgst: totalSgst.toFixed(2),
      totalNetValue: totalNetValue.toFixed(2),
    };

    setTotals(calculatedTotals);
    setInvoiceData((prev) => ({
      ...prev,
      companyAddress: props?.invoiceinfo?.companyAddress,
      companyBankDetails: props?.invoiceinfo?.companyBankDetails,
      companyCertifications: props?.invoiceinfo?.companyCertifications,
      companyCode: props?.invoiceinfo?.companyCode,
      companyCode2: props?.invoiceinfo?.companyCode,
      companyCodeDesc: props?.invoiceinfo?.companyCodeDesc,
      companyContact: props?.invoiceinfo?.companyContact,
      companyPostalCode: props?.invoiceinfo?.companyPostalCode,
      createdAt: props?.invoiceinfo?.createdAt,
      createdBy: props?.invoiceinfo?.createdBy,
      createdByName: props?.invoiceinfo?.createdByName,
      creditAvailableAmt: props?.invoiceinfo?.creditAvailableAmt,
      creditLimitExpiryDate: props?.invoiceinfo?.creditLimitExpiryDate,
      creditOutStandingAmt: props?.invoiceinfo?.creditOutStandingAmt,
      creditPeriod: props?.invoiceinfo?.creditPeriod,
      customerCode: props?.invoiceinfo?.customerCode,
      customerName: props?.invoiceinfo?.customerName,
      deliveryName: props?.invoiceinfo?.deliveryName,
      documentNumber: props?.invoiceinfo?.documentNumber,
      loadingAdviceNr: props?.invoiceinfo?.loadingAdviceNr,
      loadingStatus: props?.invoiceinfo?.loadingStatus,
      orderSchedulingNr: props?.invoiceinfo?.orderSchedulingNr,
      orderTotalValue: props?.invoiceinfo?.orderTotalValue,
      otherCustomerContactName: props?.invoiceinfo?.otherCustomerContactName,
      otherCustomerContactNumber:
        props?.invoiceinfo?.otherCustomerContactNumber,
      othersCustomerStatus: props?.invoiceinfo?.othersCustomerStatus,
      salesOfficerCode: props?.invoiceinfo?.salesOfficerCode,
      salesOfficerContactNr: props?.invoiceinfo?.salesOfficerContactNr,
      salesOfficerEmail: props?.invoiceinfo?.salesOfficerEmail,
      salesOfficerName: props?.invoiceinfo?.salesOfficerName,
      updatedAt: props?.invoiceinfo?.updatedAt,
      items: props?.invoiceinfo?.items,
      totals: calculatedTotals,
    }));
  };

  // ✅ Initial props load
  useEffect(() => {
    if (props?.invoiceinfo) {
      const updatedLineItems = props?.invoiceinfo?.items?.map((item) => {
        const orderQuantityLoad = parseFloat(item.orderQtyLoadConfirm) || 0;
        const unitPrice = parseFloat(item.unitPrice) || 0;
        const reversePercentage = parseFloat(item.reversePercentage) || 1;
        const cgst = parseFloat(item.cgst) || 0;
        const sgst = parseFloat(item.sgst) || 0;

        const basicPrice =
          Math.round((unitPrice / reversePercentage) * 100) / 100;
        const basicAmount =
          Math.round(
            (unitPrice / reversePercentage) * orderQuantityLoad * 100
          ) / 100;

        const cgstValue = Math.round(((cgst * basicAmount) / 100) * 100) / 100;
        const sgstValue = Math.round(((sgst * basicAmount) / 100) * 100) / 100;
        const gstValue = cgstValue + sgstValue;
        const netValue = (
          parseFloat(gstValue) + parseFloat(basicAmount)
        ).toFixed(2);

        return {
          ...item,
          basicPrice,
          basicAmount,
          cgstValue,
          sgstValue,
          gstValue,
          netValue,
          creditAmount: 0,
          debitAmount: parseFloat(netValue),
          isIGST: false,
          igstPercent: "",
        };
      });

      setLineItemData(updatedLineItems);
      calculateTotals(updatedLineItems); // ✅ Call here
    }
    // eslint-disable-next-line
  }, [props?.invoiceinfo]);

  const rounded = Math.round(totals.totalNetValue); // Nearest whole number
  // const difference = (rounded - totals.totalNetValue).toFixed(2);
  const difference = parseFloat((rounded - totals.totalNetValue).toFixed(2));

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
  };

  const onInputChange = ({ target: { name, value } }) => {
    setInvoiceData((invoiceData) => ({ ...invoiceData, [name]: value }));
  };

  const handleSave = async () => {
    let cgst14 = 0;
    let sgst14 = 0;
    let cgst9 = 0;
    let sgst9 = 0;

    lineItemData.forEach((item) => {
      if (item.cgst === 14) {
        cgst14 += Number(item.cgstValue) || 0;
        sgst14 += Number(item.sgstValue) || 0;
      } else if (item.cgst === 9) {
        cgst9 += Number(item.cgstValue) || 0;
        sgst9 += Number(item.sgstValue) || 0;
      }
    });
    const obj = {
      data: {
        ...invoiceData,
        generatedDate: invoiceData?.generatedDate || getTodaysData(),
        distance: invoiceData?.distance || "",
        supplyType: invoiceData?.supplyType || "",
        // transactionType: invoiceData?.transactionType || "",
        mode: invoiceData?.mode || "",
        netValue: parseFloat(rounded),
        roundOff: parseFloat(difference),
        transaction: "Sales",
        transactionType: "INV",
        items: lineItemData,
        //   cgstValue_14: cgst14,
        // sgstValue_14: sgst14,
        // cgstValue_9: cgst9,
        // sgstValue_9: sgst9,
        totals: {
          ...(invoiceData?.totals || {}),
          cgstValue_14: cgst14,
          sgstValue_14: sgst14,
          cgstValue_9: cgst9,
          sgstValue_9: sgst9,
        },
      },
    };
    // console.log(">>obj",obj)
    setDisabled(true);
    await ItemServiceV2.addInvoice(obj).then((item) => {
      if (item?.status === 200) {
        handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const documentTypeMap = {
    "101 - GST Registration": "GST",
    "100 - PAN Registration": "PAN",
    "131 - GST Registration": "GST",
  };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getLoadingAdviceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getOrderSchedulingList(obj));
  };
  const handleIGSTToggle = (index) => {
    const updatedData = [...lineItemData];
    const item = { ...updatedData[index] };

    // Get original values from props
    const originalItem = props?.invoiceinfo?.items?.[index] || {};
    const originalCGST = parseFloat(originalItem.cgst) || 0;
    const originalSGST = parseFloat(originalItem.sgst) || 0;

    const orderQuantityLoad = parseFloat(item.orderQtyLoadConfirm) || 0;
    const unitPrice = parseFloat(item.unitPrice) || 0;
    const reversePercentage = parseFloat(item.reversePercentage) || 1;

    if (!item.isIGST) {
      // ✅ Enable IGST mode and auto-fill cgst+sgst
      const igstPercent = originalCGST + originalSGST || 0;

      let basicAmount = 0;
      let basicPrice = 0;
      let gstValue = 0;
      let netValue = 0;

      if (igstPercent > 0 && orderQuantityLoad > 0) {
        basicAmount =
          Math.round(
            ((orderQuantityLoad * unitPrice) / (1 + igstPercent / 100)) * 100
          ) / 100;
        basicPrice = Math.round((basicAmount / orderQuantityLoad) * 100) / 100;
        gstValue = Math.round(((igstPercent * basicAmount) / 100) * 100) / 100;
        netValue = (basicAmount + gstValue).toFixed(2);
      }

      updatedData[index] = {
        ...item,
        isIGST: true,
        igstPercent: igstPercent.toFixed(2),
        cgstValue: 0,
        sgstValue: 0,
        basicAmount,
        basicPrice,
        gstValue,
        netValue,
        cgst: 0,
        sgst: 0,
      };
    } else {
      // Disable IGST and restore CGST/SGST from original props
      const basicPrice =
        Math.round((unitPrice / reversePercentage) * 100) / 100;
      const basicAmount =
        Math.round((unitPrice / reversePercentage) * orderQuantityLoad * 100) /
        100;

      const cgstValue =
        Math.round(((originalCGST * basicAmount) / 100) * 100) / 100;
      const sgstValue =
        Math.round(((originalSGST * basicAmount) / 100) * 100) / 100;
      const gstValue = cgstValue + sgstValue;
      const netValue = (basicAmount + gstValue).toFixed(2);

      updatedData[index] = {
        ...item,
        isIGST: false,
        igstPercent: "",
        basicPrice,
        basicAmount,
        cgstValue,
        sgstValue,
        gstValue,
        netValue,
        cgst: originalCGST,
        sgst: originalSGST,
      };
    }

    setLineItemData(updatedData);
    calculateTotals(updatedData); // ✅ Always refresh totals after change
  };

  //igst percent change
  const handleIGSTPercentChange = (value, index) => {
    const updatedData = [...lineItemData];
    const item = { ...updatedData[index] };

    const orderQuantityLoad = parseFloat(item.orderQtyLoadConfirm) || 0;
    const unitPrice = parseFloat(item.unitPrice) || 0;
    const igst = parseFloat(value) || 0;

    let basicAmount = 0;
    let basicPrice = 0;
    let gstValue = 0;
    let netValue = 0;

    if (igst > 0 && orderQuantityLoad > 0) {
      basicAmount =
        Math.round(((orderQuantityLoad * unitPrice) / (1 + igst / 100)) * 100) /
        100;
      basicPrice = Math.round((basicAmount / orderQuantityLoad) * 100) / 100;
      gstValue = Math.round(((igst * basicAmount) / 100) * 100) / 100;
      netValue = (basicAmount + gstValue).toFixed(2);
    }

    updatedData[index] = {
      ...item,
      isIGST: true,
      igstPercent: value,
      cgstValue: 0,
      sgstValue: 0,
      gstValue,
      basicAmount,
      basicPrice,
      netValue,
    };

    setLineItemData(updatedData);
    calculateTotals(updatedData); // ✅ Update totals
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Invoice Confirmation - {invoiceData?.orderSchedulingNr}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* 01 */}
        <div className="accordion mb-4" id="accordionExample" F>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Invoice Address</span>
                  <span className="subHeaderTitle">Invoice details</span>
                </Col>

                <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                  {/* <Col
                    xs={6}
                    md={6}
                    lg={6}
                    className="d-flex justify-content-end mr-2 mt-1"
                  >
                    <button className="btnTable" onClick={handlePrint}>Print Invoice</button>
                    <div style={{ display: "none" }}>
                      <PrintInvoice ref={contentRef} data={printInvoiceData} />
                    </div>
                  </Col> */}
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Col xs={12} md={12} lg={12} className="p-2">
                        {/* <p className="fw-bold mb-0">Company:</p> */}
                        <p className="text-lg mb-0">
                          {invoiceData?.companyCodeDesc}
                        </p>
                        <p className="text-lg mb-0">
                          {invoiceData?.companyAddress}
                        </p>
                      </Col>

                      <Col xs={12} md={12} lg={12} className="p-2">
                        {/* <p className="fw-bold mb-0">Address:</p> */}

                        {/* <p className="fs-5 mb-0">
                          {invoiceData?.items?.length > 0
                            ? invoiceData?.items[0]?.companyAddress
                            : ""}
                          {invoiceData?.items?.length > 0
                            ? invoiceData?.items[0]?.companyAddress
                            : ""}
                        </p> */}

                        {/* {invoiceData?.items?.length > 0 &&
                          invoiceData?.items[0]?.companyCertifications[0]
                            ?.filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType?.includes(type)
                              )
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType; // Fallback to original if not found

                              return (
                                <p key={index} className="fs-5 mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })} */}
                        {invoiceData?.items?.length > 0 &&
                          Array.isArray(
                            invoiceData.items[0]?.companyCertifications
                          ) &&
                          invoiceData.items[0].companyCertifications
                            .filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType?.includes(type)
                              )
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType;

                              return (
                                <p key={index} className="text-lg mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })}
                      </Col>

                      <Col xs={12} md={12} lg={12} className="p-2">
                        <p className="fw-bold mb-0">Billing:</p>
                        <p className="text-lg mb-0">
                          {invoiceData?.customerName}
                        </p>
                        <p className="text-lg mb-0">
                          {invoiceData?.items?.length > 0
                            ? invoiceData?.items[0]?.customerAddress.toUpperCase()
                            : ""}
                          {invoiceData?.items?.length > 0
                            ? invoiceData?.items[0]?.companyAddress.toUpperCase()
                            : ""}
                        </p>

                        {/* {invoiceData?.items?.length > 0 &&
                          invoiceData.items[0]?.certifications
                            ?.filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType?.includes(type)
                              )
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType; // Fallback to original if not found

                              return (
                                <p key={index} className="fs-5 mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })} */}
                        {invoiceData?.items?.length > 0 &&
                        Array.isArray(invoiceData.items[0]?.certifications) ? (
                          invoiceData.items[0].certifications
                            .filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType?.includes(type)
                              )
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType;

                              return (
                                <p key={index} className="text-lg mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })
                        ) : (
                          <p className="text-lg mb-0">
                            No certifications available
                          </p>
                        )}
                      </Col>
                      <Col xs={12} md={12} lg={12} className="p-2">
                        <p className="fw-bold mb-0">Shipping:</p>
                        <p className="text-lg mb-0">
                          {invoiceData?.items?.length > 0 &&
                          invoiceData?.items[0]?.shippingAddress
                            ? `${String(
                                invoiceData?.items[0]?.shippingAddress
                              ).toUpperCase()} `
                            : ""}

                          {invoiceData?.items?.length > 0 &&
                          invoiceData?.items[0]?.shippingPostalCode
                            ? String(
                                invoiceData?.items[0]?.shippingPostalCode
                              ).toUpperCase()
                            : ""}
                        </p>
                      </Col>
                      <Col xs={12} md={12} lg={12} className="p-2">
                        <p className="fw-bold mb-0">Godown:</p>
                        <p className="text-lg mb-0">
                          {invoiceData?.items?.length > 0 &&
                          invoiceData?.items[0]?.godownAddress
                            ? `${String(
                                invoiceData?.items[0]?.godownAddress
                              ).toUpperCase()} `
                            : ""}
                        </p>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/*02 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Items</span>
                  <span className="subHeaderTitle">Items details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <DataTable
                          title=""
                          columns={lineItemCol}
                          data={lineItemData}
                          // progressPending={orderSchedulingData?.status}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          // paginationTotalRows={orderSchedulingTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          // selectableRows
                        />
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Invoice details</span>
                  <span className="subHeaderTitle">Invoice details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Bags"
                            name="sumOfOrderQuantityLoad"
                            id="sumOfOrderQuantityLoad"
                            value={invoiceData?.totals?.totalBags}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Amount"
                            name="sumOfRate"
                            id="sumOfRate"
                            value={invoiceData?.totals?.totalAmount}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total CGST"
                            name="totalCgst"
                            id="totalCgst"
                            value={invoiceData?.totals?.totalCgst}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total SGST"
                            name="totalSgst"
                            id="totalSgst"
                            value={invoiceData?.totals?.totalSgst}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Round Off"
                            name="difference"
                            id="difference"
                            value={difference}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Net Amount"
                            name="totalAmount"
                            id="totalAmount"
                            // value={invoiceData?.totals?.totalNetValue}
                            value={rounded}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            {invoiceData?.items &&
                            !!invoiceData?.items[0]?.loadingOtherTruckNo ? (
                              <InputField
                                className="inputBox"
                                label="Truck No"
                                name="loadingTruckNo"
                                id="loadingTruckNo"
                                value={
                                  invoiceData?.items
                                    ? invoiceData?.items[0]?.loadingOtherTruckNo
                                    : ""
                                }
                                onChange={onInputChange}
                                disabled={true}
                              />
                            ) : (
                              <InputField
                                className="inputBox"
                                label="Truck No"
                                name="loadingTruckNo"
                                id="loadingTruckNo"
                                value={
                                  invoiceData?.items
                                    ? invoiceData?.items[0]
                                        ?.loadingTruckNoDescription
                                    : ""
                                }
                                onChange={onInputChange}
                                disabled={true}
                              />
                            )}
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="e-Way Bill Number"
                              extraLabel=""
                              name="ewayBill"
                              code="ewayBillCode"
                              description="ewayBillDesc"
                              data={ewayBillNumberData}
                              id="ewayBill"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.ewayBill}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={false}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Dispatch Document Number"
                              name="dispatchDocumnetNr"
                              id="dispatchDocumnetNr"
                              value={invoiceData?.dispatchDocumnetNr}
                              onChange={onInputChange}
                              disabled={false}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Bill of Lading / LR-RR No."
                              name="billOfLading"
                              id="billOfLading"
                              value={invoiceData?.billOfLading}
                              onChange={onInputChange}
                              disabled={false}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Terms Of Payment"
                              extraLabel=""
                              name="termsOfPayment"
                              code="termsOfPaymentCode"
                              description="termsOfPaymentDesc"
                              data={dropdownOption}
                              id="termsOfPayment"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.termsOfPayment}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={false}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Terms of Delivery"
                              type="text"
                              name="termsOfDelivery"
                              id="termsOfDelivery"
                              value={invoiceData?.termsOfDelivery}
                              onChange={onInputChange}
                              required={false}
                            />
                          </Col> */}
                          {/* {invoiceData?.ewayBill === "Yes" && (
                            <Row>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Generated Date"
                                  name="generatedDate"
                                  id="generatedDate"
                                  type="date"
                                  value={
                                    invoiceData?.generatedDate ||
                                    getTodaysData()
                                  }
                                  onChange={onInputChange}
                                  // disabled={!!diableEwaybill}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Distance"
                                  name="distance"
                                  id="distance"
                                  value={invoiceData?.distance}
                                  onChange={onInputChange}
                                  // disabled={!!diableEwaybill}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supply Type"
                                  name="supplyType"
                                  id="supplyType"
                                  value={invoiceData?.supplyType}
                                  onChange={onInputChange}
                                  // disabled={!!diableEwaybill}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Transaction Type"
                                  name="transactionType"
                                  id="transactionType"
                                  value={invoiceData?.transactionType}
                                  onChange={onInputChange}
                                  // disabled={!!diableEwaybill}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Mode"
                                  name="mode"
                                  id="mode"
                                  value={invoiceData?.mode}
                                  onChange={onInputChange}
                                  // disabled={!!diableEwaybill}
                                />
                              </Col>
                            </Row>
                          )} */}
                        </Row>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {!viewInvoiceDataStatus && (
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    onClick={handleSave}
                    disabled={disable}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default InvoiceConfirmationModal;
